import { render, staticRenderFns } from "./ColoniaCp.vue?vue&type=template&id=497c809c"
import script from "./ColoniaCp.vue?vue&type=script&lang=js"
export * from "./ColoniaCp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports